import { Component, Input, OnInit } from '@angular/core';
import { WorkProject } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-contact-persons',
  templateUrl: './ax-project-contact-persons.component.html',
  styleUrls: ['./ax-project-contact-persons.component.scss'],
})
export class AxProjectContactPersonsComponent implements OnInit {
  @Input() project: WorkProject;
  @Input() isInternalView = false;
  public accordionState: any = false;

  constructor() {
  }

  ngOnInit() {
  }
}
